import cx from 'clsx';
import Link from 'next/link';
import { useState } from 'react';
import { Avatar, Group, Menu, Text, UnstyledButton, useMantineTheme } from '@mantine/core';
import {
  IconAdjustmentsHorizontal,
  IconChevronDown,
  IconCoins,
  IconLogout,
} from '@tabler/icons-react';
import { logoutAction } from '@/actions/logout';
import { ROLE } from '@/shared/const/roles';
import { UserStoreUser, useUserStore } from '@/shared/stores/userStore';
import { userLinks } from '@/app/components/shell/navbar/links';
import { useTranslation } from '@/i18n/client';
import classes from './UserMenu.module.css';

export function UserMenu({ user }: { user: UserStoreUser }) {
  const theme = useMantineTheme();
  const [userMenuOpened, setUserMenuOpened] = useState(false);
  const unsetUser = useUserStore((state) => state.unsetUser);
  const { t } = useTranslation('links');

  const logout = async () => {
    await logoutAction();
    unsetUser();
  };

  const links = userLinks.map((link) => (
    <Link key={link.link} href={link.link} style={{ textDecoration: 'none' }}>
      <Menu.Item key={link.label} leftSection={<link.icon size={16} stroke={1.5} />}>
        {t(link.label).toUpperCase()}
        {link.link === '/cabinet/support' && user && user.support.length > 0 && (
          <span className={classes.support}>{user.support.length}</span>
        )}
      </Menu.Item>
    </Link>
  ));

  return (
    <Menu
      width={260}
      trigger='hover'
      position='bottom-end'
      transitionProps={{ transition: 'pop-top-right' }}
      onClose={() => setUserMenuOpened(false)}
      onOpen={() => setUserMenuOpened(true)}
      withinPortal
    >
      <Menu.Target>
        <UnstyledButton className={cx(classes.user, { [classes.userActive]: userMenuOpened })}>
          <Group gap={2}>
            <Avatar src={user.avatar} alt={user.name} radius='xl' size={34} />
            <Text fw={500} size='md' lh={1} mr={6} ml={12}>
              {user.name}
            </Text>

            <Text c={theme.colors.yellow[6]}>{user.coins}</Text>
            <IconCoins size={18} color={theme.colors.yellow[6]} />

            <IconChevronDown size={16} stroke={1.5} className={classes.icon} />
          </Group>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown style={{ width: '195px' }}>
        {userMenuOpened}
        {links}
        {user.role >= ROLE.SUPPORT && (
          <Link href='/dashboard' style={{ textDecoration: 'none' }}>
            <Menu.Item
              color='yellow'
              leftSection={<IconAdjustmentsHorizontal size={16} stroke={1.5} />}
            >
              {t('Dashboard').toUpperCase()}
            </Menu.Item>
          </Link>
        )}
        <Menu.Item color='red' leftSection={<IconLogout size={16} stroke={1.5} />} onClick={logout}>
          {t('Logout').toUpperCase()}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}

export default UserMenu;
